import { Reveal } from "./Reveal";
import { copy } from "@/content";

export const StrategicRole = ({ lang = "en" }) => {
  const t = copy[lang].strategic;
  return (
    <section
      className="relative py-28 sm:py-40"
      data-testid="strategic-role-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="dealer-eyebrow">STRATEGIC ROLE</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-serif text-3xl leading-[1.15] tracking-tight text-dealer-ivory sm:text-4xl lg:text-5xl">
                BEYOND
                <br />
                MANAGEMENT.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-10 max-w-md text-sm font-light leading-relaxed text-dealer-silver sm:text-base">
                {t.body}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <ul>
              {t.areas.map((area, i) => (
                <Reveal key={area} delay={0.08 * i}>
                  <li
                    className="group flex items-baseline justify-between gap-6 border-t border-dealer-ivory/10 py-6 last:border-b"
                    data-testid={`strategic-area-${i + 1}`}
                  >
                    <span className="font-serif text-lg tracking-[0.05em] text-dealer-ivory transition-colors duration-500 group-hover:text-dealer-burgundybright sm:text-xl">
                      {area}
                    </span>
                    <span className="font-serif text-xs italic text-dealer-subtle">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
